import { render } from "./ResetPassword-View.vue?vue&type=template&id=03719a43"
import script from "./ResetPassword-View.vue?vue&type=script&lang=js"
export * from "./ResetPassword-View.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__